import { __ } from '@wordpress/i18n'

export default {
  text: __('Event Data', 'dhsv_theme'),
}
